// This controller facilitates sending custom events to Google Analytics as a
// result of user interactions with the page.
//
// Usage:
//
// <body data-controller="analytics-event">
//   <a href="..."
//      data-action="analytics-event#send"
//      data-analytics-event="<%= {someKey: "some_value"}.to_json %>"
//   >
//     Hello World
//   </a>
// </body>

import { Controller } from "@hotwired/stimulus"
import ga from "../utils/ga"

export default class extends Controller {
  static targets = ["immediate"]

  connect() {
    this.immediateTargets.forEach((element) => {
      this.sendEvents(this.extractPayloadFromElement(element))
    })
  }

  send(event) {
    this.sendEvents(this.extractPayloadFromElement(event.target))
  }

  sendEditCartEvent(event) {
    const gaCustomEventData = this.extractPayloadFromElement(event.target)
    const page = "/search/edit-cart-entry" + window.location.search
    ga("send", { ...gaCustomEventData, page })
  }

  sendFilterPanelEvent(event) {
    const gaCustomEventData = this.extractPayloadFromElement(event.target)
    const ariaLabel = event.target.closest("[aria-label]").getAttribute("aria-label")
    this.sendEvents({
      ...gaCustomEventData,
      eventCategory: ariaLabel.includes("Expand") ? "FilterExpand" : "FilterCollapse",
    })
  }

  sendMiniCartEvent(event) {
    const gaCustomEventData = this.extractPayloadFromElement(event.target)
    ga("send", { ...gaCustomEventData, eventCategory: "page-header-top" })
  }

  // private

  sendEvents(payload) {
    // TODO: @arman a simple refactor will help avoid this conditional. I will
    //       come back to do this once done with bringing over all the events
    payload = Array.isArray(payload) ? payload : [["send", payload]]
    payload.forEach((entry) => ga(...entry))
  }

  extractPayloadFromElement(el) {
    const nodeWithCustomData = el.closest("[data-analytics-event]")
    const rawData = nodeWithCustomData.dataset.analyticsEvent
    return JSON.parse(rawData)
  }
}
